import React from 'react';
import { useContext } from 'react';

import DataContext from '../DataContext';
import PostItem from './PostItem';



function PostsList(props) {

    const data = useContext(DataContext);

    let postType = props.post_type ? props.post_type : 'post';

    let cssClass = postType + '__list ui-list';

    return (
        <ul className={cssClass}>
            {data.map((post, index) =>
                <PostItem key={post.id} data={post} index={index} postType={postType} />
            )}				
        </ul>

    );
      
}

export default PostsList;
